import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const MEAL_TYPE_LABELS: Record<string, string> = {
  snidane: "Snídaně",
  svacina: "Svačina",
  obed: "Oběd",
  svacina2: "Odpolední svačina",
  vecere: "Večeře",
};

export const ALL_MEAL_TYPES: { id: string; label: string }[] = [
  { id: "snidane", label: "Snídaně" },
  { id: "svacina", label: "Svačina" },
  { id: "obed", label: "Oběd" },
  { id: "svacina2", label: "Odpolední svačina" },
  { id: "vecere", label: "Večeře" },
];

export const DAY_NAMES_CS = ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"];

export function dayNameCs(dateIso: string): string {
  const d = new Date(dateIso + "T00:00:00");
  return DAY_NAMES_CS[d.getDay()];
}

export function formatDateCs(dateIso: string): string {
  const d = new Date(dateIso + "T00:00:00");
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}

export function isoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function rangeDates(fromIso: string, toIso: string): string[] {
  const out: string[] = [];
  const from = new Date(fromIso + "T00:00:00");
  const to = new Date(toIso + "T00:00:00");
  for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
    out.push(isoDate(d));
  }
  return out;
}

export function formatQuantity(qty: number, unit: string): string {
  const rounded = Math.round(qty * 100) / 100;
  return `${rounded} ${unit}`;
}
